import {
  getCommcommunityAll,
  getPointLevelThreeListById,
  getPointTypeListPage
} from "@/api/point.js";
export default {
  data() {
    return {
      communityCode: '',
      commcommunityList: [],
      blockList: [],
      pointTypeOptions: []
    }
  },
  methods: {
    // 社区列表
    async getCommcommunityAllFun() {
      const res = await getCommcommunityAll();
      this.commcommunityList = res.data.data;
    },
    // 点位类型
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointTypeOptions = res.data.data.records;
    },
  },
  computed: {
    getPointTypeName() {
      return function (id) {
        let name = "";
        this.pointTypeOptions.forEach(item => {
          if (item.id == id) {
            name = item.typeName;
          }
        });
        return name;
      };
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/baseInfo/issuesStandardManagement/components/index.js